import { memo } from 'react';
import { observer } from 'mobx-react';

import { useStore } from '../../../../../core/utils/hook';
import SectionTitle from '../../../../../components/Titles/SectionTitle';
import AccordionFAQ from '../../../../../components/Accordion/accordionFAQ';
import LinkButton from '../../../../../components/Buttons/LinkButton/LinkButton';
import { SYSTEM_PATH } from '../../../../../core/configs/constants';

import './style.scss';

const FaqTopPage = observer(({ faq }) => {
    const isShowFaq = Array.isArray(faq?.faqs) && faq?.faqs?.length > 0;

    return isShowFaq ? (
        <section id='id-section-faq' className="section-faq">
            <div className='container'>
                {faq?.title && (
                    <div className='section-faq-title'>
                        <SectionTitle title={faq?.title} />
                    </div>
                )}

                {faq?.faqs?.map((item, index) => (
                    <AccordionFAQ
                        key={`${item?.id}-${index}`}
                        item={item}
                        index={index}
                        containerClassname="faq-top-container"
                    />
                ))}

            </div>
        </section>
    ) : (
        <div className='w-100 height-50'></div>
    )
})

export default memo(FaqTopPage);
